//-----------------
// is item changed
//-----------------
export default function isItemChanged(original, now) {
  console.log('----------------------------')
  console.log('IN isItemChanged')

  console.log('ORIGINAL ITEM: ', original)
  console.log('NOW ITEM: ', now)

  const isArtefact = (original?.type ?? now?.type) === 'Artefact'

  const artefactChanged =
    isArtefact &&
    (original.name != now.name ||
      original.artefact_type != now.artefact_type ||
      original.trait != now.trait ||
      original.material != now.material ||
      original.quality != now.quality ||
      original.age != now.age ||
      original.value_lower != now.value_lower ||
      original.value_upper != now.value_upper ||
      original.estimated_value != now.estimated_value ||
      original.race != now.race ||
      original.currency != now.currency ||
      original.description != now.description ||
      original.enc != now.enc ||
      original.countable != now.countable ||
      original.unit_name != now.unit_name ||
      original.max_unit_count != now.max_unit_count)

  if (
    original.tally_qty != now.tally_qty ||
    (original.player_notes ?? original.notes) != (now.player_notes ?? now.notes) ||
    original.short_description != now.short_description ||
    original.worn_location != now.worn_location ||
    original.container != now.container ||
    original.attach_location != now.attach_location ||
    original.armour_location != now.armour_location ||
    original.hp != now.hp ||
    original.pwr_storage != now.pwr_storage ||
    original.pwr_storage_cur != now.pwr_storage_cur ||
    original.held != now.held ||
    original.equipped != now.equipped ||
    artefactChanged ||
    JSON.stringify(original.runes) != JSON.stringify(now.runes) ||
    JSON.stringify(original.non_rune_spells) != JSON.stringify(now.non_rune_spells)
  ) {
    console.log('VALUE CHANGED ', original.name)
    return true
  } else {
    console.log('VALUE NOT CHANGED ', original.name)
    return false
  }
}
